import CHALLENGES_ACTIONS from "./constants";

const initialState = {
  challenges: [],
  pages: 0,
  total: 0,
  err: null,
  isFetching: false
};

const reducers = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CHALLENGES_ACTIONS.list.request:
      return {
        ...state,
        isFetching: true
      };
    case CHALLENGES_ACTIONS.list.success:
      return {
        ...state,
        challenges: action.payload.docs,
        page: action.payload.page,
        total: action.payload.pages,
        isFetching: false,
        err: null
      };
    case CHALLENGES_ACTIONS.list.error:
      return {
        ...state,
        isFetching: false,
        err: payload
      };
    case CHALLENGES_ACTIONS.reset:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
